export enum DependencyComparisonType {
  Equals = 0,
  NotEquals = 1,
  LessThan = 2,
  MoreThan = 3,
}
